import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
export const RadioItem = ({value,label, classes}) => {
    return (
        <FormControlLabel value={value} control={<Radio />} label={label} className={classes?.labelRoot}/>
    )
}
